<div class="mp">
  <!-- Hero -->
  <section class="mp-hero">
    <div class="mp-hero-inner">
      <div class="mp-hero-copy">
        <div class="mp-eyebrow">{{ 'MAGAZINE.EYEBROW' | translate }}</div>
        <h1 class="mp-title">{{ 'MAGAZINE.TITLE' | translate }}</h1>
        <p class="mp-sub">
          {{ 'MAGAZINE.SUB' | translate }}
        </p>
      </div>
      <div class="mp-hero-visual">
        <span class="mp-hero-blob" aria-hidden="true"></span>
        <img
          class="mp-hero-photo anim-cover-float"
          src="/magazines-hero-cutout.png"
          alt="Open magazine on a stack of issues with a sprout of knowledge"
          width="520"
          height="360"
          decoding="async"
          appImgFade
        />
      </div>
    </div>
  </section>

  <div class="mp-shell">
    @if (magazineService.loading()) {
      <p class="mp-status">{{ 'MAGAZINE.LOADING' | translate }}</p>
    } @else if (magazineService.error()) {
      <p class="mp-status">{{ magazineService.error() }}</p>
    } @else if (!magazineService.magazines().length) {
      <p class="mp-status">{{ 'MAGAZINE.EMPTY' | translate }}</p>
    } @else {
      <div class="magazine-grid">
        @for (mag of magazineService.magazines(); track mag.MagId) {
          @if (hasReader(mag)) {
            <a class="magazine-card magazine-card-link" [routerLink]="['/magazine', mag.MagId]">
              <div class="magazine-card-cover">
                @if (coverSrc(mag); as cover) {
                  <img [src]="cover" [alt]="mag.MagTitle" loading="lazy" decoding="async" appImgFade />
                } @else {
                  <span aria-hidden="true">📖</span>
                }
                @if (mag.MagIssueNumber) {
                  <span class="magazine-card-issue">{{ mag.MagIssueNumber }}</span>
                }
              </div>
              <div class="magazine-card-body">
                <div class="magazine-card-category">{{ mag.MagGenre || 'Literary' }}</div>
                <h3 class="magazine-card-title">{{ mag.MagTitle }}</h3>
                @if (mag.MagDescription) {
                  <p class="magazine-card-desc">{{ mag.MagDescription }}</p>
                }
                <div class="magazine-card-footer">
                  <span class="magazine-date">{{ mag.MagPublishDate | date: 'MMM y' }}</span>
                  <span class="magazine-read-btn">{{ 'MAGAZINE.READ' | translate }}</span>
                </div>
              </div>
            </a>
          } @else {
            <article class="magazine-card">
              <div class="magazine-card-cover">
                @if (coverSrc(mag); as cover) {
                  <img [src]="cover" [alt]="mag.MagTitle" loading="lazy" decoding="async" appImgFade />
                } @else {
                  <span aria-hidden="true">📖</span>
                }
                @if (mag.MagIssueNumber) {
                  <span class="magazine-card-issue">{{ mag.MagIssueNumber }}</span>
                }
              </div>
              <div class="magazine-card-body">
                <div class="magazine-card-category">{{ mag.MagGenre || 'Literary' }}</div>
                <h3 class="magazine-card-title">{{ mag.MagTitle }}</h3>
                @if (mag.MagDescription) {
                  <p class="magazine-card-desc">{{ mag.MagDescription }}</p>
                }
                <div class="magazine-card-footer">
                  <span class="magazine-date">{{ mag.MagPublishDate | date: 'MMM y' }}</span>
                </div>
              </div>
            </article>
          }
        }
      </div>
    }
  </div>
</div>
